import { useSearchParams } from "react-router-dom";
import { useAppData, useUserStore } from "providers/RootStoreProvider";

export const useAppInitializationDone = () => {
    const [searchParams] = useSearchParams();
    const usidParam = searchParams.get("usid");
    const { userWebSession } = useUserStore();
    const { amplitudeUserId, ampliIDLoading } = useAppData();

    return !ampliIDLoading && userWebSession?.session?.user?.amplitudeSessionId && amplitudeUserId && amplitudeUserId === usidParam;
};
